const CONTEXT_TAG = 'context';
const CONTEXT_BLOCK_RE = new RegExp(`<${CONTEXT_TAG}>[\\s\\S]*?</${CONTEXT_TAG}>`, 'g');
const ATTACHMENT_CONTEXT_INSTRUCTIONS = 'Metadata for the files attached to this message. Reference an attachment in tool calls by its file_id.';
export function buildContextWrappedPrompt(context, prompt, instructions) {
    const instructionsPart = instructions ? `\n${instructions}` : '';
    return `<${CONTEXT_TAG}>${JSON.stringify(context)}${instructionsPart}</${CONTEXT_TAG}>${prompt}`;
}
export function buildAttachmentContextPrompt(files, prompt) {
    if (!files.length) {
        return prompt;
    }
    const attachments = files.map((f) => ({
        file_id: f.file_id,
        name: f.name,
        content_type: f.content_type,
    }));
    return buildContextWrappedPrompt({ attachments }, prompt, ATTACHMENT_CONTEXT_INSTRUCTIONS);
}
export function stripContextBlocks(text) {
    if (!text) {
        return text;
    }
    return text.replace(CONTEXT_BLOCK_RE, '').trimStart();
}
